import { useUnifiedSearchV2Query, SearchType } from "api";
import NotFound from "components/NotFound";
import { isEmpty } from "lodash-es";
import React, { useState } from "react";
import PeopleSearchCard from "./PeopleSearchCard";
import Loader from "./Loader";
import { SearchTag } from "layouts/MainLayout/components/Search";

interface SearchProps {
  search: string;
  close: () => void;
  isAnchor?: boolean;
  handleAddChip?: (data: SearchTag) => void;
  handleGetFilterPosts?: (data: SearchTag | undefined) => void;
}

interface IState {
  loading: boolean;
  page: number;
  hasMore: boolean;
  results: Array<any>;
}

const People: React.FC<SearchProps> = ({
  search,
  close,

  isAnchor,
  handleAddChip,
  handleGetFilterPosts,
}) => {
  const observer = React.useRef<any>();
  const [end, setEnd] = useState(false);

  const { data, fetchMore, loading } = useUnifiedSearchV2Query({
    variables: {
      searchText: search,
      type: SearchType.User,
      offset: 0,
      limit: 20,
    },
  });

  const lastElement = React.useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !end) {
          fetchMore({
            variables: { offset: data?.unifiedSearchV2?.length },
          }).then(({ data }) => {
            if (isEmpty(data?.unifiedSearchV2 || [])) {
              setEnd(true);
            }
          });
        }
      });
      if (node) observer.current.observe(node);
    },
    [end, setEnd, loading, data?.unifiedSearchV2?.length]
  );

  return (
    <div
      onClick={close}
      // onClick={() => {
      //   console.log(searchContentFreeze, "FREEZE");
      //   searchContentFreeze === false ? close : null;
      // }}
      className="mobile-search-container"
    >
      {data?.unifiedSearchV2?.map((item: any, key, arr) => {
        const last = arr.length === key + 1;
        return (
          <div key={key} ref={last ? lastElement : null}>
            <PeopleSearchCard
              user={item?.user}
              isAnchor={isAnchor}
              handleAddChip={handleAddChip}
              handleGetFilterPosts={handleGetFilterPosts}
            />
          </div>
        );
      })}
      {loading ? (
        <Loader />
      ) : (
        isEmpty(data?.unifiedSearchV2) && (
          <NotFound title={`No people for "${search}"`} />
        )
      )}
    </div>
  );
};

export default People;
